import { createContext } from "react";

export interface IFieldContext {
    id?: string;
}

export default createContext<IFieldContext>({});
